import {ResultCode, defaultError, WebError, isError} from "@hybird/core/error";

export const flutterError = {
  NOT_FIND_USB_DEVICE: new ResultCode(21001, "串口设备不存在"),
  NOT_CONNECT_USB_DEVICE: new ResultCode(21002, "串口设备连接失败")
}